import Loading from './Loading';
import './Loading.css';
import { connect } from 'react-redux';

// Redux
const mapStateToProps = (state) => {
  return {
    isLoading: state.loading.isLoading,
    percent: state.loading.percent
  };
}

const ConnectedLoading = connect(
  mapStateToProps
)(Loading);

export default ConnectedLoading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js